import styled from "styled-components";
import arrowLeft from "assets/images/arrow-left.png";
import { fonts } from "styles";

export const Container = styled.main`
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: black;
  position: relative;

  @media screen and (max-width: 1000px) {
    flex-direction: column;
    height: auto;
  }
`;

export const Content = styled.section`
  display: flex;
  width: 100%;
  max-width: 50%;
  height: 100vh;
  position: relative;
  z-index: 2;

  &.left {
    padding: 48px 125px 48px 48px;
    align-items: center;
    justify-content: flex-end;
  }

  &.right {
    align-items: center;
    justify-content: flex-start;
    padding: 48px 48px 48px 0;
  }

  @media screen and (max-width: 1000px) {
    max-width: 100%;
    height: 100%;

    &.left {
      align-items: center;
      justify-content: center;
      padding: 48px 48px 40px 48px;
    }

    &.right {
      align-items: center;
      justify-content: center;
      padding: 0 48px 83px 48px;
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  min-height: 492px;
  max-width: 424px;

  @media screen and (max-width: 1000px) {
    max-width: 100%;
    min-height: unset;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 78px;
  line-height: 75px;
  margin-bottom: 24px;
  letter-spacing: -2px;
  color: white;
  text-transform: uppercase;

  span {
    color: #2fc1e6;

    small {
      font-size: 78px;
      color: #e7b757;
    }
  }

  /* @media screen and (max-width: 1056px) {
    font-size: 83px;
    line-height: 80px;

    span {
      font-size: 22px;
      line-height: 21px;
    }
  } */

  @media screen and (max-width: 414px) {
    font-size: 53px;
    line-height: 51px;
    span {
      small {
        font-size: 53px;
      }
    }
  }
`;

export const Text = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 22px;
  color: white;
  max-width: 543px;

  p {
    margin-bottom: 32px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 1000px) {
    max-width: 100%;
  }

  @media screen and (max-width: 414px) {
    font-size: 15px;
  }
`;

export const Icon = styled.img.attrs({ src: arrowLeft })`
  margin-right: 16px;
`;

export const Button = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  padding: 16px 32px;
  background-color: #e865bc;
  max-height: 52px;
  border-radius: 26px;
  font-family: ${fonts.BentonSansWideMedium};
  font-size: 16px;
  line-height: 22px;
  color: black;
  margin-bottom: 40px;
  transition: 300ms ease;

  &:hover {
    transform: scale(0.9);
  }
`;

export const Credit = styled.h6`
  font-family: ${fonts.BentonSansWide};
  font-size: 16px;
  line-height: 22px;
  color: white;
  margin: 40px 0 64px 0;

  @media screen and (max-width: 414px) {
    margin: 24px 0 40px 0;
  }
`;

export const Video = styled.div`
  display: flex;
  align-items: center !important;
  width: 100%;
  height: 100vh;
  position: fixed;
  overflow: hidden;
  z-index: 1;
  top: 0;
  left: 0;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.5;
  }

  /* @media screen and (max-width: 414px) {
    display: none;
  } */
`;
